import { Suspense, lazy } from 'react';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import "../node_modules/bootstrap/dist/js/bootstrap.esm"
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import { Route, Routes } from 'react-router-dom';
// import Home from './components/website/home/Home';
const Navbar =lazy(()=>import('../src/components/website/navbar/Navbar'))
const GolferSignup =lazy(()=>import('../src/components/website/golferSignup/GolferSignup'))
const GolferLogin =lazy(()=>import('../src/components/website/golferlogin/GolferLogin'))
const Home = lazy(()=>import('../src/components/website/home/Home'))
const Aboutus = lazy(()=>import('../src/components/website/aboutus/Aboutus'))
const Contactus = lazy(()=>import('../src/components/website/contactus/Contactus'))
const Gallary = lazy(()=>import('../src/components/website/gallary/Gallary'))
const Letslearn = lazy(()=>import('../src/components/website/letslearn/Letslearn'))
const Letsplay = lazy(()=>import('../src/components/website/letsplay/Letsplay'))
const Letsshop = lazy(()=>import('../src/components/website/letsshop/Letsshop'))
const Footer = lazy(()=>import('../src/components/website/footer/Footer'))
const Gdashboard = lazy(()=>import('../src/components/website/golferDashboard/Gdashboard'))
const Myprofile = lazy(()=>import('../src/components/website/myprofile/Myprofile'))
const PlayedEvent = lazy(()=>import('../src/components/website/playedEventPage/PlayedEvent'))
const EventPage = lazy(()=>import('../src/components/website/eventpage/EventPage'))
const CoachCalendar = lazy(()=>import('../src/components/website/coachCalendar/CoachCalendar')) 
const Errorpage = lazy(()=>import('../src/components/website/errorpage/Errorpage')) 
const DashboardTab =lazy(()=>import('../src/components/website/golferDashboard/DashboardTab.jsx'))


function App() {
  return (
    <>
   <Suspense> <Navbar/></Suspense>
    <Routes>
      <Route exact='true' path='/' element={<Suspense> <Home/></Suspense>}/>
      <Route exact='true' path='/golferSignup' element={<Suspense> <GolferSignup/></Suspense>}/>
      <Route exact='true' path='/golferlogin' element={<Suspense> <GolferLogin/></Suspense>}/>
      <Route exact='true' path='/golfer-dashboard' element={<Suspense> <Gdashboard/></Suspense>}/>
      <Route exact='true' path='/golfertab' element={<Suspense><DashboardTab/></Suspense>}/>
      <Route exact='true' path='/myprofile' element={<Suspense> <Myprofile/></Suspense>}/>
      <Route exact='true' path='/playedEvent/:id' element={<Suspense> <PlayedEvent/></Suspense>}/>
      <Route exact='true' path='/eventPage/:id' element={<Suspense> <EventPage/></Suspense>}/>
      <Route exact='true' path='/about' element={<Suspense> <Aboutus/></Suspense>}/>
      <Route exact='true' path='/contact' element={<Suspense> <Contactus/></Suspense>}/>
      <Route exact='true' path='/gallary' element={<Suspense> <Gallary/></Suspense>}/>
      <Route exact='true' path='/letslearn' element={<Suspense> <Letslearn/></Suspense>}/>
      <Route exact='true' path='/letsplay' element={<Suspense> <Letsplay/></Suspense>}/>
      <Route exact='true' path='/letshop' element={<Suspense> <Letsshop/></Suspense>}/>
      <Route exact='true' path='/coachCalendar/:coachId' element={<Suspense> <CoachCalendar/></Suspense>}/>
      <Route exact='true' path='*' element={<Errorpage />} />
    </Routes>
    <Suspense><Footer/></Suspense>
    </>
  );
}

export default App;
